/**
 * 主题选择器组件
 * Theme Selector Component
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import useTheme from '../hooks/useTheme';
import './ThemeSelector.css';

const ThemeSelector = () => {
  const { t } = useTranslation();
  const { toggleTheme, isRetro, isSketch, isDamaged } = useTheme();

  const getThemeIcon = () => {
    if (isRetro) return '🎮';
    if (isSketch) return '✏️';
    if (isDamaged) return '💥';
    return '💻';
  };

  const getThemeLabel = () => {
    if (isRetro) return t('theme.retro');
    if (isSketch) return t('theme.sketch');
    if (isDamaged) return t('theme.damaged');
    return t('theme.modern');
  };

  const getThemeClass = () => {
    if (isRetro) return 'retro';
    if (isSketch) return 'sketch';
    if (isDamaged) return 'damaged';
    return 'modern';
  };

  return (
    <div className="theme-selector">
      <button
        onClick={toggleTheme}
        className={`theme-toggle-btn ${getThemeClass()}`}
        title={t('theme.toggle')}
      >
        <span className="theme-icon">{getThemeIcon()}</span>
        <span className="theme-label">{getThemeLabel()}</span>
      </button>
    </div>
  );
};

export default ThemeSelector;
